module.exports = __webpack_public_path__ + "static/camper-046339d2c08e4f62c5181385f115ccd4.svg";